// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
// components
import { Typography } from '@lyearn/ui';
// config
import contentConfig from '@/modules/content/config';

// context
import { useLearningContent } from '../context';
// types
import { TypeProps } from '../types';

function Type({
  variant = 'body-short-03',
  color = 'text-text-secondary',
  className,
  ...rest
}: TypeProps) {
  const { t } = useTranslation();
  const { content } = useLearningContent();
  const typeLabel = contentConfig[content.type!].label.title;

  if (!typeLabel) {
    return null;
  }

  return (
    <Typography className={className} color={color} variant={variant} {...rest}>
      {t(typeLabel)}
    </Typography>
  );
}

export default React.memo(Type);
